// extracted by mini-css-extract-plugin
module.exports = {"vfContainer":"e_pr","followed":"e_qr","followedIcon":"e_rr","follow":"e_sr","followIcon":"e_tr"};